import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowRedoDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowRedoDown"><Path d="M19.1891 15.75L15.9392 18.9999L16.9999 20.0605L22.0605 14.9999L16.9999 9.93923L15.9392 10.9999L19.1893 14.25H3.5V6.5H13V5H2V15.75H19.1891Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowRedoDown;
